export const ASSIGN_ITEM_TO_STORE = 'ASSIGN_ITEM_TO_STORE'
export const REMOVE_ITEM_FROM_STORE = 'REMOVE_ITEM_FROM_STORE'
export const REDUCE_QUANTITY = 'REDUCE_QUANTITY'
export const SEND_MESSAGE = `SEND_MESSAGE`